import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
const STRIKE_OUT_BUTTON_WITH_PRINT_HEIGHT = 120;
const PRINT_RADIUS = 40;
const STRIKE_OUT_HEIGHT = 3;
const style = () => {
    const { borderRadius3, borderRadiusFull, colorBgPrimary, space2, space4 } = theme();
    return StyleSheet.create({
        button: {
            alignItems: "flex-start",
            borderRadius: borderRadius3,
            flexDirection: "column",
            justifyContent: "space-between",
            minHeight: STRIKE_OUT_BUTTON_WITH_PRINT_HEIGHT,
            paddingHorizontal: space4,
            paddingVertical: space4,
        },
        buttonText: {
            textDecorationLine: "line-through",
        },
        container: {
            flex: 1,
        },
        print: {
            borderRadius: borderRadiusFull,
            height: PRINT_RADIUS,
            width: PRINT_RADIUS,
        },
        strikeOut: {
            backgroundColor: colorBgPrimary,
            borderRadius: borderRadiusFull,
            height: STRIKE_OUT_HEIGHT,
            left: -4,
            position: "absolute",
            top: PRINT_RADIUS / 2,
            transform: [{ rotate: "45deg" }],
            width: PRINT_RADIUS + space2,
        },
        text: {
            padding: 0,
        },
    });
};
export { style };
